import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'

import { Spinner, Pagination } from 'shared/atoms'
import type { TableNode } from '@table-library/react-table-library/types/table'
import { ITable } from './types'
import { cn } from 'utils/style'

const isInteractiveTarget = (event: Event) =>
	event.target instanceof Element && event.target.closest('a, button, input, label') !== null

export const Table2 = ({
	columns,
	data,
	isLoading,
	select,
	prev,
	next,
	customStyles = {},
	className,
	onClick,
	onRowClick
}: ITable) => {
	if (isLoading) return <Spinner />

	const theme = useTheme([getTheme(), customStyles])
	const columnsKey = columns.map((column: { label: string }) => column.label).join('|')

	const handleRowClick = (node: TableNode, event: Event) => {
		if (!isInteractiveTarget(event)) onRowClick?.(node)
	}

	return (
		<>
			<div className={cn('relative mb-9 px-6 py-3 lg:px-0 [&_table]:static', className)}>
				<CompactTable
					key={columnsKey}
					columns={columns}
					data={data}
					theme={theme}
					layout={{ custom: true, horizontalScroll: true, fixedHeader: true }}
					select={select}
					rowProps={onRowClick ? { onClick: handleRowClick } : undefined}
				/>
			</div>
			{prev || next ? (
				<div className="flex items-center justify-center md:justify-end">
					{prev || next ? (
						<Pagination
							onClick={onClick ? onClick : () => {}}
							prev={prev ?? null}
							next={next ?? null}
						/>
					) : null}
				</div>
			) : null}
		</>
	)
}
